import api from '@/api/v2';
import apiV2 from '@/api/v2';
export var QuestionType;
(function (QuestionType) {
    QuestionType["TEXT"] = "text";
    QuestionType["RADIO"] = "radio";
    QuestionType["CHECKBOX"] = "checkbox";
    QuestionType["FILE"] = "file";
})(QuestionType || (QuestionType = {}));
export var SurveyUserStatus;
(function (SurveyUserStatus) {
    SurveyUserStatus["IN_VERIFICATION"] = "IN_VERIFICATION";
    SurveyUserStatus["REJECTED"] = "REJECTED";
    SurveyUserStatus["APPROVED"] = "APPROVED";
    SurveyUserStatus["NEEDS_REVISION"] = "NEEDS_REVISION";
})(SurveyUserStatus || (SurveyUserStatus = {}));
export var SurveyStatus;
(function (SurveyStatus) {
    SurveyStatus["WAITING"] = "WAITING";
    SurveyStatus["IN_VERIFICATION"] = "IN_VERIFICATION";
    SurveyStatus["NEEDS_REVISION"] = "NEEDS_REVISION";
    SurveyStatus["REJECTED"] = "REJECTED";
    SurveyStatus["APPROVED"] = "APPROVED";
})(SurveyStatus || (SurveyStatus = {}));
export const SURVEY_ANSWER_SEPARATOR = ';;;';
export const getUserSurveysList = async (params = {}) => {
    const { data } = await api.get(`/surveys/my`, {
        params,
    });
    return data;
};
export const submitSurveyAnswers = async (id, answers, files, comments, userId, placeId) => {
    const { data } = await api.post(`/surveys/${id}/answers`, {
        answers,
        files,
        comments,
    }, {
        params: {
            userId,
            placeId,
        },
    });
    return data;
};
export const getSurveysList = async (params) => {
    const { data } = await apiV2.get('/surveys', {
        params,
    });
    return data;
};
export const getSurveyUsers = async (surveyId, params) => {
    const { data } = await apiV2.get(`/surveys/${surveyId}/users`, { params });
    return data;
};
export const getSurveyUserResponse = async (surveyId, userId) => {
    const { data } = await apiV2.get(`/surveys/${surveyId}/users/${userId}`);
    return data;
};
export const createSurveyQuestionComment = async (surveyId, commentData) => {
    await apiV2.post(`/surveys/${surveyId}/comments`, commentData);
};
export const getSurveyQuestionComments = async (surveyUserId, questionIdx) => {
    const params = questionIdx !== undefined ? { questionIdx: questionIdx.toString() } : {};
    const { data } = await apiV2.get(`/surveys/comments/${surveyUserId}`, { params });
    return data;
};
export const deleteSurveyQuestionComment = async (commentId) => {
    await apiV2.delete(`/surveys/comments/${commentId}`);
};
export const updateSurveyQuestionComment = async (commentId, updateData) => {
    await apiV2.patch(`/surveys/comments/${commentId}`, updateData);
};
export const updateSurveyUserQuestionStatus = async (surveyUserId, questionIdx, updateData) => {
    await apiV2.patch(`/surveys/users/${surveyUserId}/${questionIdx}`, updateData);
};
export const sendSurveyReminder = async (surveyId, users) => {
    await apiV2.post(`/surveys/${surveyId}/publishment`, {
        users,
        isReminder: true,
    });
};
export const sendSurveyRejectedNotification = async (surveyId, users) => {
    await apiV2.post(`/surveys/${surveyId}/rejected-notification`, {
        users,
    });
};
